import { Component, OnInit } from '@angular/core';
import { QrReaderService } from './share/services/qr-reader.service';
import { Observable } from 'rxjs';
import { Platform } from '@ionic/angular';
import { PushNotifications, Token, PushNotificationSchema, ActionPerformed } from '@capacitor/push-notifications';
import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';
import { AuthService } from './share/services/auth.service';
import { GoogleAuth } from '@codetrix-studio/capacitor-google-auth';


@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
  isScanRequired$: Observable<boolean>;

  constructor(
    private readonly qrReaderSrv: QrReaderService,
    private readonly platform: Platform,
    private readonly authService: AuthService,
  ) {
    window.addEventListener('keyboardDidShow', function () {
      document?.activeElement?.scrollIntoView({ behavior: 'smooth' });
      console.log('existe active element', document?.activeElement)
    });
    this.isScanRequired$ = this.qrReaderSrv.isScanRequired;

    //this.initializeApp();
  }

  ngOnInit(): void {
    this.setupPushNotifications();
    this.openSettings();

    this.platform.ready().then(() => {
      this.authService.initializeGoogleAuth();
    });
  }

  openSettings() {
    if (Capacitor.getPlatform() === 'android') {
      (window as any).openAndroidSettings?.();
    }
  }

  setupPushNotifications() {
    // Pedir permisos solo en Android 13+
    PushNotifications.requestPermissions().then(result => {
      if (result.receive === 'granted') {
        // Permiso concedido, registrar para obtener token
        PushNotifications.register();

        // Escuchar el token
        PushNotifications.addListener('registration', (token: Token) => {
          console.log('Token push:', token.value);
          // Aquí puedes enviarlo a tu backend
        });

        // Manejar errores de registro
        PushNotifications.addListener('registrationError', (error: any) => {
          console.error('Error de registro', error);
        });

        // Notificación recibida en foreground
        PushNotifications.addListener('pushNotificationReceived', (notification: PushNotificationSchema) => {
          console.log('Notificación recibida:', notification);
        });

        // Acción del usuario sobre la notificación
        PushNotifications.addListener('pushNotificationActionPerformed', (action: ActionPerformed) => {
          console.log('Acción realizada:', action);
        });
      } else {
        console.warn('Permiso de notificaciones denegado');
        // Opcional: abrir configuración
        if (Capacitor.getPlatform() === 'android') {
          this.openSettings(); // Lleva al usuario a habilitar permisos manualmente

        }
      }
    });
  }


  setupPush() {
    PushNotifications.requestPermissions().then(result => {
      if (result.receive === 'granted') {
        PushNotifications.register();
      } else {
        // Muestra un mensaje guiando al usuario
        console.log('El usuario denegó el permiso de notificaciones');
      }
    });
  }

  stopScan() {
    this.qrReaderSrv.scanRequired = false;
  }

  initializeApp() {
    this.platform.ready().then(() => {
      // Evento cuando la app se va a cerrar o se suspende
      App.addListener('appStateChange', async (state: any) => {
        if (!state.isActive) {
          console.log('App suspendida o cerrada → cerrando sesión');
          await this.authService.logout();
        }
      });
    });
  }
}
